import { ModuleRegistry } from "seneca-common/features/module/registry";

import { registerComponentStaticInformation as registerConceptModuleConsts } from "./concept/static";
import { registerComponentStaticInformation as registerDelveModuleConsts } from "./delve/static";
import { registerComponentStaticInformation as registerEquationModuleConsts } from "./equation/static";
import { registerComponentStaticInformation as registerExactListModuleConsts } from "./exact-list/static";
import { registerComponentStaticInformation as registerFlashcardModuleConsts } from "./flashcard/static";
import { registerComponentStaticInformation as registerFlowModuleConsts } from "./flow/static";
import { registerComponentStaticInformation as registerGridModuleConsts } from "./grid/static";
import { registerComponentStaticInformation as registerHierarchyModuleConsts } from "./hierarchy/static";
import { registerComponentStaticInformation as registerHyperFlashcardModuleConsts } from "./hyper-flashcard/static";
import { registerComponentStaticInformation as registerImageChangeModuleConsts } from "./image-change/static";
import { registerComponentStaticInformation as registerImageDescriptionModuleConsts } from "./image-description/static";
import { registerComponentStaticInformation as registerImageLabelModuleConsts } from "./image-label/static";
import { registerComponentStaticInformation as registerImageMultiChoiceModuleConsts } from "./image-multi-choice/static";
import { registerComponentStaticInformation as registerImageModuleConsts } from "./image/static";
import { registerComponentStaticInformation as registerImageListModuleConsts } from "./imagelist/static";
import { registerComponentStaticInformation as registerListModuleConsts } from "./list/static";
import { registerComponentStaticInformation as registerMindmapModuleConsts } from "./mindmap/static";
import { registerComponentStaticInformation as registerMultipleChoiceModuleConsts } from "./multiplechoice/static";
import { registerComponentStaticInformation as registerMultiSelectConsts } from "./multiSelect/static";
import { registerComponentStaticInformation as registerPatternModuleConsts } from "./pattern/static";
import { registerComponentStaticInformation as registerQuestionModuleConsts } from "./question/static";
import { registerComponentStaticInformation as registerSimpleCalculationModuleConsts } from "./simple-calculation/static";
import { registerComponentStaticInformation as registerTextBlockModuleConsts } from "./text-block/static";
import { registerComponentStaticInformation as registerTogglesModuleConsts } from "./toggles/static";
import { registerComponentStaticInformation as registerVideoModuleConsts } from "./video/static";
import { registerComponentStaticInformation as registerWordfillModuleConsts } from "./wordfill/static";
import { registerComponentStaticInformation as registerWorkedExampleModuleConsts } from "./worked-example/static";
import { registerComponentStaticInformation as registerWrongWordModuleConsts } from "./wrong-word/static";

export default function registerComponentStaticInformation(
  moduleRegistry: ModuleRegistry
) {
  registerConceptModuleConsts(moduleRegistry);
  registerDelveModuleConsts(moduleRegistry);
  registerEquationModuleConsts(moduleRegistry);
  registerExactListModuleConsts(moduleRegistry);
  registerFlashcardModuleConsts(moduleRegistry);
  registerFlowModuleConsts(moduleRegistry);
  registerGridModuleConsts(moduleRegistry);
  registerHierarchyModuleConsts(moduleRegistry);
  registerHyperFlashcardModuleConsts(moduleRegistry);
  registerImageModuleConsts(moduleRegistry);
  registerImageChangeModuleConsts(moduleRegistry);
  registerImageDescriptionModuleConsts(moduleRegistry);
  registerImageLabelModuleConsts(moduleRegistry);
  registerImageListModuleConsts(moduleRegistry);
  registerListModuleConsts(moduleRegistry);
  registerMindmapModuleConsts(moduleRegistry);
  registerMultipleChoiceModuleConsts(moduleRegistry);
  registerPatternModuleConsts(moduleRegistry);
  registerTogglesModuleConsts(moduleRegistry);
  registerVideoModuleConsts(moduleRegistry);
  registerWordfillModuleConsts(moduleRegistry);
  registerWorkedExampleModuleConsts(moduleRegistry);
  registerWrongWordModuleConsts(moduleRegistry);
  registerTextBlockModuleConsts(moduleRegistry);
  registerQuestionModuleConsts(moduleRegistry);
  registerImageMultiChoiceModuleConsts(moduleRegistry);
  registerMultiSelectConsts(moduleRegistry);
  registerSimpleCalculationModuleConsts(moduleRegistry);
}
